import React, { FC, Fragment, ReactNode, useEffect } from 'react';

interface IPageWrap {
  title: string;
  pageTitle?: string;
  children: ReactNode;
}

const PageWrap: FC<IPageWrap> = ({ title, pageTitle, children }) => {
  useEffect(() => {
    document.title = `Hazel - Admin | ${title}`;
  }, [title]);

  return (
    <Fragment>
      {pageTitle && (
        <div className="capitalize text-2xl font-sentient-variable text-black pb-2">
          {pageTitle}
        </div>
      )}
      {children}
    </Fragment>
  );
};

export default PageWrap;
